import script from "./SecIncidentList.vue?vue&type=script&setup=true&lang=js"
export * from "./SecIncidentList.vue?vue&type=script&setup=true&lang=js"

import "./SecIncidentList.vue?vue&type=style&index=0&id=5de06684&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5de06684"]])

export default __exports__